import React from 'react';
import { Button, Form as AntForm } from 'antd';
import { defaultFormTailLayout } from 'common/config/formLayout';
import { useFormatMessage } from 'common/hooks/useFormatMessage';

interface SaveButtonProps {
  loading: boolean;
  id?: string;
}

export const SaveButton: React.FC<SaveButtonProps> = ({
  loading,
  id = 'button-save',
}) => {
  const intlMessage = useFormatMessage();

  return (
    <AntForm.Item {...defaultFormTailLayout}>
      <Button id={id} loading={loading} type="primary" htmlType="submit">
        {loading ? intlMessage({ id: 'saving' }) : intlMessage({ id: 'save' })}
      </Button>
    </AntForm.Item>
  );
};
